import { isNil } from 'lodash';
import selectors from '../rootSelectors';
import * as lcApiActions from '../common/api/lcActions';
import {
    activateNextButton,
    blockScreen,
    deactivateNextButton,
    unblockScreen,
} from '../common/screen/screenActions';
import { narrateStart } from '../common/audio/audioActions';
import { playAvatarAudio } from '../common/avatar/avatarActions';
import { LC_FETCH_RETRY } from '../common/api/apiRetryGetConstants';
import {
    resetSelectedIndex,
    selectPossibleResponse,
    setIsQuestionCompleted,
} from '../common/questions/questionsActions';
import { LC } from '../constants/measure';
import { LC_DEMO_VIDEO_PLAYER_ID } from '../common/components/demoVideos/demoVideoConstants';

export const SET_SELECTED_PASSAGE_ID = 'SET_SELECTED_PASSAGE_ID';
export const SET_LC_CONTENT = 'SET_LC_CONTENT';
export const SET_JPLAYER_OPTION = 'SET_JPLAYER_OPTION';
export const SET_MEDIA = 'SET_MEDIA';
export const PLAYLIST_PLAY = 'PLAYLIST_PLAY';
export const UPDATE_SELECTED_COMPREHENSION_RESPONSE = 'UPDATE_SELECTED_COMPREHENSION_RESPONSE';
export const SET_PASSAGE_HALF = 'SET_PASSAGE_HALF';
export const CLEANUP_PASSAGE = 'CLEANUP_PASSAGE';

export const setSelectedPassageId = passageId => ({
    type: SET_SELECTED_PASSAGE_ID,
    passageId,
});

export const setLCContent = content => ({
    type: SET_LC_CONTENT,
    content,
});

export const updateSelectedComprehensionResponse = payload => ({
    type: UPDATE_SELECTED_COMPREHENSION_RESPONSE,
    payload,
});

export const setPassageHalf = passageHalf => ({
    type: SET_PASSAGE_HALF,
    passageHalf,
});

export const cleanupPassage = () => ({
    type: CLEANUP_PASSAGE,
});

export const fetchLCContent = () => (dispatch, getStore) => {
    const state = getStore();
    const passageId = selectors.getSelectedPassageId(state);

    return dispatch(lcApiActions.getPassage(passageId, LC_FETCH_RETRY)).then(passage => {
        dispatch(setLCContent(passage));
    });
};

export const createLCResult = () => (dispatch, getStore) => {
    const state = getStore();
    const result = selectors.findResultFor(state, { measure: LC.MEASURE, isComplete: false });

    if (result) return Promise.resolve(result.id);

    return dispatch(lcApiActions.createResult());
};

export const saveComprehensionResponse = (questionIndex, isLast = false) => (
    dispatch,
    getStore,
) => {
    const state = getStore();
    const response = selectors.getLCComprehensionResult(state, questionIndex);

    return dispatch(lcApiActions.saveComprehensionResponse(response, isLast));
};

export const narrateScreen = avatarAudios => dispatch => {
    if (avatarAudios) {
        dispatch(blockScreen());
        dispatch(narrateStart());
        return dispatch(playAvatarAudio(avatarAudios)).then(() => {
            dispatch(unblockScreen());
        });
    }
    return Promise.resolve();
};

export const playPlaylist = playlistIndex => ({
    type: PLAYLIST_PLAY,
    index: playlistIndex,
    id: LC_DEMO_VIDEO_PLAYER_ID,
});

export const saveSelectedResponse = (responseIndex, questionIndex) => dispatch =>
    dispatch(updateSelectedComprehensionResponse({ questionIndex, responseIndex }));

export const onSelectAnswer = (responseIndex, questionIndex) => dispatch => {
    dispatch(setIsQuestionCompleted(questionIndex, responseIndex !== undefined));
    dispatch(activateNextButton());
    dispatch(selectPossibleResponse(responseIndex));
    dispatch(saveSelectedResponse(responseIndex, questionIndex));
};

export const onLCQuestionChange = questionIndex => (dispatch, getStore) => {
    const state = getStore();
    const selectedResponse = selectors.getLCSelectedResponse(state, questionIndex);
    const isQuestionCompleted = selectors.getIsQuestionCompleted(state, questionIndex);
    if (!isNil(selectedResponse)) {
        dispatch(selectPossibleResponse(selectedResponse));
    } else {
        dispatch(resetSelectedIndex());
        dispatch(deactivateNextButton());
    }
    if (isQuestionCompleted) {
        dispatch(activateNextButton());
    } else {
        dispatch(deactivateNextButton());
    }
};
